import { QuestionBase } from './question-base';

/*
Sample:
new InfoExpirationDateQuestion({
  key: 'brave',
  class: 'col-1',
  value: {
    seatsAmount: 1,
    expirationDate: '10/10/2010'
  },
  order: 8
})
*/
export class InfoExpirationDateQuestion extends QuestionBase<string> {
  controlType = 'infoexpirationdate';

  constructor(options: {} = {}) {
    super({ ...options, designSystem: false });
  }

  onDeleteQuestion() {
    super.onDeleteQuestion();
  }
}
